<template>
  <div class="newsDetails">
    <div class="newsTitle"> {{ ctx.title }}</div>
    <div class="details">
      <div class="time">发布时间：{{ ctx.time }}</div>
      <div class="source">来源：{{ ctx.target }}</div>
    </div>
    <div class="content" v-html="ctx.details"></div>
  </div>
</template>

<script>
import { apiGetNewsDetails } from "../../api/index";

export default {
  name: "newsDetails",
  metaInfo: {
    title: '新闻详情-爱情地产',
    meta: [{
      name: 'keyWords',
      content: '爱情地产'
    },
    {
      name: 'description',
      content: ''
    }]
  },
  data() {
    return {
      // detail: {},
        contents: [],
        ctx: {
          title: "",
          time: "",
          target: "",
          details: "",
        },
    };
  },
  // created() {
  //   apiGetNewsDetails(this.$route.params.id).then((data) => {
  //     if (data.data.status == 1) {
  //       this.detail = data.data.detail;
  //     }
  //   });
  // },
  methods: {
    
    init() {
      let id = this.$route.params.id;
      apiGetNewsDetails(id).then((data) => {
        if (data.data.status == 1) {
          this.contents = data.data.news;
          this.ctx = {
            title: data.data.detail.title,
            time: this.forMatter(data.data.detail.create_time * 1),
            target: data.data.detail.laiyuan,
            details: data.data.detail.content,
          };
          // if (!!data.data.up.id) {
          //   this.up = data.data.up;
          // } else {
          //   this.up = {
          //     id: "-1",
          //     title: "无",
          //   };
          // }

          // if (!!data.data.down.id) {
          //   this.down = data.data.down;
          // } else {
          //   this.down = {
          //     id: "-1",
          //     title: "无",
          //   };
          // }
        }
      });
    },
    forMatter(d) {
      var date = new Date(d);
      var getyear = date.getFullYear();
      var getmonth =
        date.getMonth() + 1 >= 10
          ? date.getMonth() + 1
          : "0" + (date.getMonth() + 1);
      var getday = date.getDate() >= 10 ? date.getDate() : "0" + date.getDate();

      return getyear + "." + getmonth + "." + getday;
    },
    routeTo(item) {
      if (item.id != this.$route.params.id) {
        this.$router.push({
          name: "NewsDetails",
          params: {
            id: item.id,
          },
        });
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped lang='less'>
* {
  margin: 0;
  padding: 0;
}
img {
  width: 100%;
}
.newsDetails {
  padding: 30px 15px;
  .newsTitle {
    font-family: "苹方-简 中黑体";
    color: #000;
    font-size: 14px;
    line-height: 20px;
    font-weight: 600;
    margin-bottom: 5px;
  }
  .details {
    display: flex;
    font-size: 12px;
    line-height: 17px;
    color: #ccc;
    display: flex;
    margin-bottom: 5px;
    .time{
      margin-right: 20px;
    }
  }
  /deep/.content {
    color: #666;
    font-size: 12px;
    line-height: 20px;
    margin-bottom: 5px;
    p{
      margin-bottom: 0 !important;
      img{
        width: 100% !important;
      }
    }
  }
}
</style>